import { Button, CircularProgress } from "@mui/material";
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";

import CustomDialog from "../CustomDialog/CustomDialog";
import CustomLoader from "../CustomLoader/CustomLoader";
import CustomToast from "../Toast/CustomToast";
import DataTable from "react-data-table-component";
import { ENDPOINT } from "../../services/endPoints";
import FilterDataComponent from "./FilterDataComponent";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import UpdateCell from "./CustomCells/UpdateCell";
import UserDetail from "./CustomCells/UserDetail";
import dayjs from "dayjs";
import { downloadXLSX, genericFirstCapitalLetter } from "../../utils/helpers";
import { filterFromData } from "./tableHelper";
import useMasterApi from "../../services/useMasterApi";
import { useMemo } from "react";
import { useState } from "react";
import useToast from "../../hooks/useToast";

const sortIcon = <KeyboardArrowDownIcon />;

const CustomDataTable = ({ columns, rowData, isCustom = false,  isCommentAdded, tableTitle, endPoint, excludedKeys,
   customKeyName, compareValue, customWidth, conditionalRowStyles, hospital_id,doc_form_code, customQueryParam=null }) => {
  const { getWithQueryParams, loading, data: masterData } = useMasterApi();
  const { getWithQueryParams: getFullExcelData, loading: fullDataLoading, data: fullDataCSV } = useMasterApi();
  const { toastMessage, toast, toastType, setToast, showToast } = useToast()
  const { loading: statusUpdateLoading, data: statusUpdateResponse, put } = useMasterApi();
  const [fullDowlodData, setFullDowlodData] = useState();

  const [columnData, setColumnData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);

  const [perPage, setPerPage] = useState(10);


  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);


  const filteredItems = filterFromData(isCustom ? rowData : masterData.values.rows, filterText);

  const handleDelete = async (row, payload) => {
    endPoint==="/hospital" ? put(`${ENDPOINT.HOSPITAL_ACTIVATE_DEACTIVATE}/${row.hospital_id}`, payload) : put(`${ENDPOINT.NURSE_ACTIVATE_DEACTIVATE}/${row.nurses_id}`, payload)
  }

  useEffect(() => {
    if (statusUpdateResponse.success) {
      showToast("success", "Successfully Updated")
      getWithQueryParams(endPoint, { page: 1, limit: perPage });
    }
  }, [statusUpdateResponse])


  const Export = ({ onExport }) => (
   fullDataLoading ? <CircularProgress/> : <Button size="small" onClick={(e) => {
      onExport(e.target.value)}}>
      Export XLSX
    </Button>
  );

  useEffect(() => {
    if (!isCustom) {
          getWithQueryParams(endPoint, { page: 1, limit: 10 });
          getFullExcelData(`${endPoint}/xls`, { page: 1, limit: 100000 });
    }
  }, []);

  useEffect(()=>{
    if(fullDataCSV){
      setFullDowlodData(fullDataCSV)
    }
  },[fullDataCSV])

  useEffect(()=>{
    if(isCommentAdded?.length || isCommentAdded?.data){
      getWithQueryParams(endPoint, { page: 1, limit: perPage });
    }
  },[isCommentAdded])

  const actionsMemo = useMemo(
    () => <Export onExport={() => downloadXLSX(isCustom ? rowData : fullDowlodData)} />,
    [masterData, rowData, fullDowlodData]
  );
  const handlePageChange = (page) => {
    if (!isCustom) {
        getWithQueryParams(endPoint, { page: page, limit: perPage });
    }
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    if (!isCustom) {
        getWithQueryParams(endPoint, { page: page, limit: newPerPage });
    }
    setPerPage(newPerPage);
  };

  // fields whose values we needed to be in capitalize format
  const capitalizeFields = ["patient_name", "facility_type", "patient_gender"]

  useEffect(() => {
    if (Object.keys(masterData).length > 0 && !isCustom) {
      setTotalRows(masterData.total);
      if (masterData.values.rows.length) {
        const keys = Object.keys(masterData.values.rows[0]);
        const newColumnsData = keys.map((key) =>
          !excludedKeys.includes(key) && endPoint !== ENDPOINT.PATIENT && endPoint !== ENDPOINT.FEEDBACK && endPoint !== ENDPOINT.DASHBOARD_REFERREDTEST && endPoint !== ENDPOINT.DASHBOARD_REJECTEDTEST
          && endPoint!== ENDPOINT.DASHBOARD_ALLTEST && endPoint!== `${ENDPOINT.DOCTOR_COMMENTS}/${doc_form_code}` && endPoint !== `${ENDPOINT.PATIENT_REFERRED_LIST}/${hospital_id}`
          && endPoint!== `${ENDPOINT.NURSE_DETAILS_FILTER}${customQueryParam}` && endPoint !== ENDPOINT.NURSE
          ? {
            name: compareValue?.includes(key) ? customKeyName[key] : key,
            maxWidth: customWidth ? customWidth[key] : undefined,
            selector: (row) => key==="form_type" ? row["form_type"] === "2" ? "Eye Form" : "Foot Form" : row[key],
            cell: (row) => <UpdateCell fullRow={row} row={row[key]} endPoint={endPoint} isRoute keys={key}/>,
          } : !excludedKeys.includes(key) ? {
            name: compareValue?.includes(key) ? customKeyName[key] : key,
            maxWidth: customWidth ? customWidth[key] : undefined,
            minWidth: key === "facility_name" ? "300px" : undefined,
            selector: (row) => key==="form_type" ? row["form_type"] === "2" ? "Eye Form" : "Foot Form" : key=== "form_accept_reject" ? row[key] === null ? "N/A" : row[key] === "1" ? "Accepted" : "Rejected" :
             key==="createdAt" ? dayjs(row[key]).format("DD-MM-YYYY") : capitalizeFields.includes(key) ? genericFirstCapitalLetter(row[key]) : genericFirstCapitalLetter(row[key]),
          } : null
        ).filter(Boolean);
        if (endPoint !== ENDPOINT.PATIENT && endPoint !== ENDPOINT.FEEDBACK &&  endPoint !== `${ENDPOINT.DOCTOR_COMMENTS}/${doc_form_code}` && endPoint !== ENDPOINT.DASHBOARD_REFERREDTEST
           && endPoint !== ENDPOINT.DASHBOARD_REJECTEDTEST
           && endPoint !== ENDPOINT.DASHBOARD_ALLTEST && endPoint !== `${ENDPOINT.PATIENT_REFERRED_LIST}/${hospital_id}` && endPoint!== ENDPOINT.NURSE_DETAILS &&
           endPoint!== `${ENDPOINT.NURSE_DETAILS_FILTER}${customQueryParam}`)  {
          newColumnsData.push({
            name: "Update",
            maxWidth: '150px',
            cell: (row) => <UpdateCell row={row} endPoint={endPoint}/>,
            
          },
            {
              name: "Active/Inactive",
              maxWidth: '150px',
              cell: (row) => <CustomDialog row={row} handleDeleteRow={handleDelete} isLoading={statusUpdateLoading} endPoint={endPoint}/>,
            });
        }
        if (endPoint === ENDPOINT.PATIENT){
          newColumnsData.push({
            name: "Update",
            cell: (row) => <UpdateCell row={row} endPoint={endPoint}/>,
          });
        }
        if (endPoint === ENDPOINT.PATIENT || endPoint === ENDPOINT.DASHBOARD_REFERREDTEST || endPoint === ENDPOINT.DASHBOARD_ALLTEST ||
          endPoint === ENDPOINT.DASHBOARD_REJECTEDTEST || endPoint === `${ENDPOINT.PATIENT_REFERRED_LIST}/${hospital_id}` ||
          endPoint=== `${ENDPOINT.NURSE_DETAILS_FILTER}${customQueryParam}`
        ) {
          newColumnsData.push({
            name: "Details",
            cell: (row) => <UserDetail row={row} endPoint={endPoint} customQueryParam={customQueryParam}/>
          });
        }
        setColumnData(newColumnsData);
      }
    }
  }, [masterData.values.rows]);

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <FilterDataComponent
        filterText={filterText}
        setFilterText={setFilterText}
        resetPaginationToggle={resetPaginationToggle}
        setResetPaginationToggle={setResetPaginationToggle}
      />
    );
  }, [filterText, resetPaginationToggle]);

  return (
    <>
      <DataTable
        title={tableTitle}
        columns={isCustom ? columns : columnData}
        data={filteredItems}
        sortIcon={sortIcon}
        highlightOnHover
        progressPending={loading}
        progressComponent=<CustomLoader />
        paginationResetDefaultPage={resetPaginationToggle}
        subHeader
        subHeaderComponent={subHeaderComponentMemo}
        pagination={isCustom ? false : true}
        paginationServer
        paginationTotalRows={totalRows}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 50]}
        paginationPerPage={perPage}
        actions={actionsMemo}
        conditionalRowStyles={conditionalRowStyles ? conditionalRowStyles : undefined}
      />
      {toast && <CustomToast
        open={toast}
        toastMessage={toastMessage}
        setToast={setToast}
        toastType={toastType}
      />}
    </>
  );
};

export default CustomDataTable;
